import './ContentBuilderTemplate.scss';
import React from 'react';
import { usePropsHandler } from '../../EventInterceptor/usePropsHandler';
import { cnContentBuilderTemplate } from './index';
import { Grid, GridItem } from '@dataartdev/uikit/Grid';
import { TwoSideLargeBanner } from '../../Redesign/TwoSideLargeBanner/TwoSideLargeBanner';
import { IRoot109 } from './models/CTI_109.props';

export const ContentBuilderTemplate: React.FC<IRoot109> = props => {
  const { type, contentId } = usePropsHandler(
    cnContentBuilderTemplate(),
    props
  );

  const typeNumber = type.toString();

  return (
    <div
      className={cnContentBuilderTemplate({ type: typeNumber })}
      id={contentId}
    >
      <Grid
        breakpoints={{
          desktop: { cols: 12 },
          tablet: { cols: 12 },
          mobile: { cols: 12 },
        }}
      >
        <GridItem
          breakpoints={{
            desktop: { col: 10, colStart: 2 },
            tablet: { col: 12 },
            mobile: { col: 12 },
          }}
        >
          <TwoSideLargeBanner {...props} />
        </GridItem>
      </Grid>
    </div>
  );
};

export default ContentBuilderTemplate;
